import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { OutputNodeView } from '../views/OutputNode';

export const outputDefinition: NodeDefinition<'output'> = {
  label: 'Output',
  showInPalette: false,
  paletteColor: 'bg-orange-100 border-orange-500 text-orange-700',
  miniMapColor: '#f97316',
  defaultData: { label: 'Output' },
  view: OutputNodeView,
  run: (_node, ctx) => {
    ctx.captureFunctionOutput?.(ctx.lastValue);
  },
  isTerminal: true,
  help: {
    title: [t('Output')],
    description: [
      r('関数', 'かんすう'),
      t('の'),
      r('処理', 'しょり'),
      t('を'),
      r('終', 'お'),
      t('える'),
      r('出口', 'でぐち'),
      t('です。'),
    ],
  },
};